import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  FormControl,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";

// import { D5VALI } from "../../../Validation";
import { Box } from "react-bootstrap-icons";
import ComponentLoader from "../../../ComponentLoader";

function ArE9Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);
  const [inves,setInves] = useState([])

  const [investigatorName,setInvestigatorName] = useState("")
  const [documentDescription,setDocumentDescription] = useState("")
  const [releasedLevel,setReleasedLevel] = useState("")
  const [leadAuthor,setLeadAuthor] = useState("")

  const [investigatorNameErr,setInvestigatorNameErr] = useState(false)
  const [documentDescriptionErr,setDocumentDescriptionErr] = useState(false)
  const [releasedLevelErr,setReleasedLevelErr] = useState(false)
  const [leadAuthorErr,setLeadAuthorErr] = useState(false)
  const [realeaseType,setRealeaseType]=useState([]);
  const [stateType,setStateType] =useState([]);
  const [loader,setLoader] =useState(true);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [insti, setInsti] = useState();

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    // resolver: yupResolver(D5VALI),
  });

  const backs = () => {
    navigate("/ArE9");
  };

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
     
      handleReleaseType(tok);
      handleStateType(tok)
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("items purchased");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const tok = localStorage.getItem("token");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const institute = localStorage.getItem("loginId");
    setInsti(institute);
    handleInvestigators(tok,institute)
  }, []);

  const edit = (item) => {
    console.log(item);
    setInvestigatorName(item.investigatorId);
    setDocumentDescription(item.documentDesc);
    setReleasedLevel(item.releasedLevel);
    setLeadAuthor(item.participantType);
    setId(item.id);
  };

  const handleReleaseType = async (token,TeamleaderRole) => {
    console.log(token);
    

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"TeamleaderRole"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setRealeaseType(data);setLoader(false);
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };

  const handleStateType = async (token,RealeaseType) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"RealeaseType"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setStateType(data);setLoader(false);
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };



// Investigator 
const handleInvestigators = async (token,id) => {
  const h = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
  try {
    const { data } = await axios.get(`${window.BASE}${window.INVESTIGATORIDMAPNAME}${id}`, {
      headers: h,
    });
    console.log(data);setLoader(false);
    setInves(data);
  } catch (error) {
    console.log(error);setLoader(false);
  }
};

  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const d = {
      id,
      InvestigatorId: investigatorName,
      DocumentDesc: documentDescription,
      ReleasedLevel: releasedLevel,
      ParticipantType: leadAuthor,
      IAMRSId: state.id,
      InstituteId: parseInt(insti),
      RptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.Er9SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/ArE9");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          alert(data.errorMsgs[0])
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.Er9EDIT}`, d, {
          headers: h,
        });
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully updated");
          navigate("/ArE9");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun=()=>{
    if(!investigatorName){
      setInvestigatorNameErr(true)
      document.getElementById("investigatorName").focus()
    }else if(!documentDescription){
      setDocumentDescriptionErr(true)
      document.getElementById("documentDescription").focus()
    }else if(!releasedLevel){
      setReleasedLevelErr(true)
      document.getElementById("releasedLevel").focus()
    }else if(!leadAuthor){
      setLeadAuthorErr(true)
      document.getElementById("leadAuthor").focus()
    }else{
      handleLeavepage()
    }
   }

  return (
    <div className="main-container-margin">
         <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/GeneralAR">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span> E9. Policy documents developed (Policy documents / Inventory / Technology Gap assessment / Impact assessment)

</span>
        </div>
      </div>

      {/* <form className="from-mains" onSubmit={handleSubmit(handleLeavepage)}> */}
        <div className="form-control">
          <h5 style={{ margin: 20 }}> E9. Policy documents developed (Policy documents / Inventory / Technology Gap assessment / Impact assessment)
 
</h5>

          <FormControl style={{ width: "48%", margin: 12 }} error={investigatorNameErr}  id="investigatorName">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Name of the faculty
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="investigatorName"
              value={investigatorName}
              label="Programme Type"
              size="small"
              sx={{ width: "100%" }}
              onChange={(e) => {
                setInvestigatorName(e.target.value)
                setInvestigatorNameErr(false)
              }}
            >
            {inves?.map((row,index) => {
              return (
                <MenuItem key={row.index} value={row.id}>
                  {row.investigatorName}
                </MenuItem>
              );
            })}
            </Select>
          </FormControl>

          <TextField
            error={documentDescriptionErr}
            id="documentDescription"
            label="Description of the document"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={documentDescription}
            onChange={(e) => {
                setDocumentDescription(e.target.value)
                setDocumentDescriptionErr(false)
              }}
          />
{/* 
          <TextField
            error={releasedLevelErr}
            id="releasedLevel"
            label="State / National /International"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={releasedLevel}
            onChange={(e) => {
                setReleasedLevel(e.target.value)
                setReleasedLevelErr(false)
              }}
          /> */}

<FormControl
            style={{ width: "48%", margin: 12 }}
            error={releasedLevelErr}
            id="releasedLevel"
          >
            <InputLabel id="demo-simple-select-helper-label" size="small">
            State / National /International
            </InputLabel>
            <Select
              variant="outlined"
              // label="Rating Type"
              style={{ height: "45px" }}
              name="leadAuthor"
            
              value={releasedLevel}
              onChange={(e) => {
                setReleasedLevel(e.target.value)
                setReleasedLevelErr(false)
              }}
            >
              {stateType?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.lovName}>
                    {option.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          {/* <TextField
            error={leadAuthorErr}
            id="leadAuthor"
            label="Lead author / Member"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={leadAuthor}
            onChange={(e) => {
                setLeadAuthor(e.target.value)
                setLeadAuthorErr(false)
              }}
          /> */}

<FormControl
            style={{ width: "48%", margin: 12 }}
            error={leadAuthorErr}
            id="leadAuthor"
          >
            <InputLabel id="demo-simple-select-helper-label" size="small">
            Lead author / Member
            </InputLabel>
            <Select
              variant="outlined"
              // label="Rating Type"
              style={{ height: "45px" }}
              name="leadAuthor"
            
              value={leadAuthor}
              onChange={(e) => {
                setLeadAuthor(e.target.value)
                setLeadAuthorErr(false)
              }}
            >
              {realeaseType?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.lovName}>
                    {option.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA",padding:"5px",borderRadius:"3px",width:"80px",color:"#fff" }}
              onClick={backs}
            >
              Back
            </button>
            <button type="submit" style={{paddingTop:"5px"}} className="sbmit-buttons" onClick={formValidateFun}>
            Save
            </button>
          </div>
        </div>
      {/* </form> */}
    </div>
  );
}

export default ArE9Inside;
